var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"width":"60%","visible":_vm.show},on:{"update:visible":function($event){_vm.show=$event},"open":_vm.open,"close":_vm.close}},[_c('div',{attrs:{"id":"player"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }